import { Button } from '@design/components/button/Button';
import { DropdownEntry, DropdownGroup } from '@design/components/dropdown-menu/dropdown-group/DropdownGroup';
import { DropdownMenu } from '@design/components/dropdown-menu/DropdownMenu';
import { Icon } from '@design/components/icon/Icon';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './ConditionDropdown.module.scss';

type ConditionDropdownProps = {
  conditionLabel: string;
  onEdit: () => void;
  onDelete: () => void;
};

export const ConditionDropdown = ({
  conditionLabel,
  onEdit,
  onDelete,
}: ConditionDropdownProps) => {
  const { t } = useTranslation(['scenario']);

  const items: DropdownEntry[] = [
    {
      label: t('scenario:conditionDropdown.edit'),
      key: 'new',
      iconName: 'Pencil',
      onClick: onEdit,
    },
    {
      label: (
        <span className={styles.removeText}>
          <Icon iconName="Trash" size={16} className={styles.trashIcon} />
          {t('scenario:conditionDropdown.remove')}
        </span>
      ),
      key: 'remove',
      onClick: onDelete,
    },
  ];

  return (
    <DropdownMenu
      triggerNode={
        <Button
          className={styles.condition}
          label={conditionLabel}
          iconName="ChevronLightDown"
          variant="empty"
          iconPosition="right"
        />
      }
    >
      <DropdownGroup items={items} />
    </DropdownMenu>
  );
};
